const BASE = process.env.REACT_APP_BACKEND_URL;
const KEY = "bentolife.token";

export function getToken() {
  return localStorage.getItem(KEY);
}

export function setToken(t) {
  if (t) localStorage.setItem(KEY, t);
  else localStorage.removeItem(KEY);
}

export async function api(path, opts = {}) {
  const { method = "GET", body, auth = true } = opts;
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  const res = await fetch(`${BASE}/api${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    const err = new Error((data && data.detail) || res.statusText || "request_failed");
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

export const backendUrl = BASE;
